import Component from '@ember/component';
import {
  action,
  computed,
  get,
  getProperties,
  set,
  setProperties,
} from '@ember/object';
import { equal } from '@ember/object/computed';
import { next } from '@ember/runloop';
import { service } from '@ember/service';
import { task, timeout } from 'ember-concurrency';

/* attrs
    - individual
    - currentReport
    - checkForShowCoachingPaginationModal - boolean
    - actions
      - onShowCoachingPaginationModalChange(show - boolean)
        - only fired if checkForShowCoachingPaginationModal is true
*/
export default Component.extend({
  tagName: 'nav',
  coachingService: service(),
  router: service(),

  individual: null,
  report: null,
  checkForShowCoachingPaginationModal: false,
  showCoachingPaginationModal: false,

  reportIndex: computed('report.id', function () {
    let { individual, report } = getProperties(this, 'individual', 'report');
    return get(individual, 'sortedReports').indexOf(report);
  }),

  isPrevDisabled: equal('reportIndex', 0),
  isNextDisabled: computed(
    'reportIndex',
    'individual.reports.length',
    function () {
      return this.reportIndex >= get(this, 'individual.reports.length') - 1;
    },
  ),

  checkShowCoachingPaginationModal: task(function* () {
    let showCoachingPaginationModal = this.scrollDiv.scrollTop > 100;
    if (showCoachingPaginationModal !== this.showCoachingPaginationModal) {
      set(this, 'showCoachingPaginationModal', showCoachingPaginationModal);
      this.onShowCoachingPaginationModalChange(showCoachingPaginationModal);
    }
    yield timeout(250);
    this.checkShowCoachingPaginationModal.perform();
  }).keepLatest(),

  didInsertElement() {
    this._super(...arguments);
    if (this.checkForShowCoachingPaginationModal) {
      let scrollDiv = document.getElementsByClassName('bm-content')[0];
      setProperties(this, {
        scrollDiv,
        showCoachingPaginationModal: false,
      });
      this.checkShowCoachingPaginationModal.perform();
    }
  },

  handleOnOpen: action(function (dropdown) {
    setProperties(this, {
      dropdown,
      pageVal: '',
    });
  }),

  closeDropdown: action(function () {
    next(() => {
      let dropdown = this.dropdown;
      if (dropdown) {
        dropdown.actions.close();
      }
    });
  }),

  prevReport: action(function () {
    let prevReport = get(this, 'individual.sortedReports')[
      this.reportIndex - 1
    ];
    this.router.transitionTo(
      'coaching.individuals.individual.report',
      get(prevReport, 'id'),
    );
  }),

  nextReport: action(function () {
    let nextReport = get(this, 'individual.sortedReports')[
      this.reportIndex + 1
    ];
    this.router.transitionTo(
      'coaching.individuals.individual.report',
      get(nextReport, 'id'),
    );
  }),
});
